<div class="container-fluid">
  <div class="row mt-4">
    <div class="col text-center">
      <button class="btn btn-dark" type="button" (click)="fileInput.click()"
              [disabled]="isSimpleFlow && !purchaseOrder?.id">
        <i class="fa fa-plus"></i>
        Add Files
        <input type="file" class="d-none" #fileInput multiple (change)="addFiles($event)">
      </button>
    </div>
  </div>

  <div class="row mt-3" *ngFor="let poFile of poFiles; let $index = index">
    <div class="col">
      <div class="file-container" [class.border-success]="poFile.is_main_file">
        <a [matTooltip]="'Set as Purchase Order'"
           matTooltipPosition="after"
           *ngIf="!isRCDSS"
           (click)="setAsMainFile(poFile)"
           [class.text-success]="poFile.is_main_file"
           class="file-icon d-flex justify-content-center align-items-center flex-column">
          <small>{{isRCDSS ? '' : 'Purchase Order'}}</small>
          <i class="fa fa-file-o"></i>
        </a>
        <div>
          <a class="text-primary" (click)="viewFile(poFile)">{{ poFile.file_name }}</a>
          <div class="text-center">
            <small>{{ poFile.file_size | fileSize}}</small>
          </div>
        </div>

        <a matTooltip="Remove File" class="remove-file" (click)="removeFile(poFile, $index)">
          <i class="fa fa-trash"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative" *ngIf="!isSimpleFlow">
  <button class="ml-1 mr-1 button-back" type="button" mat-raised-button matStepperPrevious>Back</button>
  <button class="ml-1 mr-1" type="button" mat-raised-button color="grey" (click)="saveDraft.emit()">
    Save to Draft
  </button>
  <button class="ml-1 mr-1" type="button" mat-raised-button
          color="primary" matStepperNext>Next
  </button>
  <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
          (click)="discard.emit()">
    <i class="fa fa-trash"></i>
    Discard
  </button>
</div>

